module.exports = __webpack_public_path__ + "static/media/homeitem2.9e824e77.png";